module.exports = "/8/2-con-tr-va-mang-mot-chieu/index.html.3c8778e4780dd872224eef1cc8f11097.json"


/*****************
 ** WEBPACK FOOTER
 ** ./content/generated/30788.md
 ** module id = 568
 ** module chunks = 0
 **/